var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigation = function SvgNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.039 2.16a.601.601 0 0 1 .8.798l-8.807 18.59a.6.6 0 0 1-1.124-.11l-1.87-7.479-7.479-1.87a.6.6 0 0 1-.111-1.124zM4.476 11.331l6.202 1.55.078.025a.6.6 0 0 1 .359.412l1.55 6.2 7.369-15.557z"
  })));
};
export default SvgNavigation;